export const META_BODY = '#5b616e';

/** Theme spacing units: horizontal inset for `DesktopReportSection` body (tabs use the negative of this for edge-to-edge chrome). */
export const CLASS_ACTION_REPORT_CARD_PAD_X = 3;

/** Claim / notice button label (not returned by the analysis API). */
export const DEFAULT_VISIT_CLAIM_CTA_LABEL = 'Visit Official Site to Claim';

/** Bold lead-in for the AI disclaimer rendered at the top of the class actions report. */
export const AI_DISCLAIMER_PREFIX = 'Disclaimer:' as const;

/** Body copy following `AI_DISCLAIMER_PREFIX` in the overview panel disclaimer. */
export const AI_DISCLAIMER_BODY =
  'This report includes AI-generated content, which may contain errors, inconsistencies, and/or outdated information. Such content is provided for informational purposes only and should not be relied upon for any specific purpose without verification of its accuracy or completeness.';

/** `sectionId` for v2 `ReportSection` + `HiddenSectionsProvider` (`class_action_lawsuit_report`). */
export const CLASS_ACTION_REPORT_SECTION_IDS = {
  highlights: 'class_action_lawsuit_highlights',
  status: 'class_action_lawsuit_status',
  key_details: 'class_action_lawsuit_key_details',
  documents: 'class_action_lawsuit_documents',
  next_steps: 'class_action_lawsuit_next_steps',
  related_cases: 'class_action_lawsuit_related_cases',
} as const;
